import React from "react";

// material-ui components
import withStyles from "material-ui/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";

import SimpleInput from "components/SimpleInput/SimpleInput.jsx";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    top: "3px",
    position: "relative",
  }
};

const fields = [
];

class Step3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldState: {},
    };
    this.change = this.change.bind(this);
  }
  // function that returns true if value is email, false otherwise
  change(event, stateName, type, stateNameEqualTo) {
    let value = event.target?event.target.value:null;
    this.props.change({ [stateName]: value });
    this.setState({ [stateName]: value });
  }
  isValidated() {
    return true;
  }
  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify="center">
        <ItemGrid xs={12} sm={12}>
          <h4 className={classes.infoText}>
            
          </h4>
        </ItemGrid>
        <ItemGrid xs={12} sm={6}>
          {fields.map((prop,key)=>{
          return (
            <SimpleInput 
              success={this.state.fieldState[prop.name] === "success"}
              error={this.state.fieldState[prop.name] === "error"}
              key={key} 
              type={prop.type}  
              name={prop.name} 
              label={prop.label} 
              classes={classes} 
              size={prop.size} 
              handler={this.change} 
            />
          )})}          
        </ItemGrid>
      </GridContainer>
    );
  }
}

export default withStyles(style)(Step3);



// WEBPACK FOOTER //
// ./src/views/Receiver/ApplicationWizardSteps/Step3.jsx